// extracted by mini-css-extract-plugin
export default {"survey_content":"index_survey_content_DgFiG"};